jQuery( function projectTags($){

    const $tag = $('.portada__tag');
    let is_visible = false;
    let the_timeout = false;
    let is_scrolling = false;
    let current_scroll = 0;

    if(!$tag.length){
        return;
    }

    doScroll();
    checkVisibility();
    window.addEventListener('scroll', doScroll, {passive: true});
    setInterval( checkVisibility, 200);

    function doScroll(){
        current_scroll = window.scrollY;
        is_scrolling = true;
        if( the_timeout ) {
            clearTimeout( the_timeout );
        }
        the_timeout = setTimeout( function(){
            is_scrolling = false;
        },100);
    }

    function checkVisibility(){
        if( current_scroll <= 0 || is_scrolling) {
            showTag();
        } else {
            hideTag();
        }
    }

    function showTag(){
        if( is_visible ){ return; }
        is_visible = true;
        console.log('showing');
        $tag.addClass('visible');
    }
    function hideTag(){
        if( !is_visible ){ return; }
        is_visible = false;
        console.log('hiding');
        $tag.removeClass('visible');
    }

});